import React from 'react'

export default function Effec() {
  return (
    <div>
      Effec
    </div>
  )
}
